import { ApolloClient, ApolloLink } from '@apollo/client';
import { ApolloProvider } from '@apollo/client/react';
import UploadHttpLink from 'apollo-upload-client/UploadHttpLink.mjs';
import { FC } from 'react';

import { EnvConfig } from '../../config/configMapping';
import { authLink } from './authLink';
import { errorLink } from './errorLink';
import { getApolloCache } from './getApolloCache';

type Props = {
  envConfig: EnvConfig;
  children: React.ReactNode;
};

export const ApolloProviderInit: FC<Props> = ({ envConfig, children }) => {
  const httpLink = new UploadHttpLink({
    uri: envConfig.apollo.uri,
    // Tell fetch to include the `altitude_session` HttpOnly cookie on cross-origin requests
    // from the SPA to the backend. CORS on the backend reflects the SPA origin and sets
    // `Access-Control-Allow-Credentials: true` so the browser actually attaches the cookie.
    credentials: 'include',
    // Apollo's CSRF prevention rejects a multipart POST without a header that a simple form post could not set.
    headers: { 'Apollo-Require-Preflight': 'true' },
  });

  const client = new ApolloClient({
    // Auth > Error > HTTP ordering suggested here https://github.com/apollographql/apollo-client/issues/5697#issuecomment-574747467
    link: ApolloLink.from([authLink(), errorLink, httpLink]),
    cache: getApolloCache(),
    devtools: { enabled: envConfig.apollo.connectToDevTools },
  });

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
